import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import { alpha } from "@material-ui/core/styles/colorManipulator";
import classnames from "classnames";

import {
  useDataProvider,
  useNotify,
  useRedirect,
  Button,
  Confirm,
} from "react-admin";

import { DeleteIcon } from "../../../components/common/iconography";
import { logError } from "../../../utils/appUtils";
import { InventoryStatus } from "../../../utils/constants";
import { deepRedirect } from "../../../utils/utils";

const useStyles = makeStyles(
  (theme) => ({
    deleteButton: {
      color: theme.palette.error.main,
      "&:hover": {
        backgroundColor: alpha(theme.palette.error.main, 0.12),
        // Reset on mouse devices
        "@media (hover: none)": {
          backgroundColor: "transparent",
        },
      },
    },
  }),
  { name: "RaDeleteWithConfirmButton" },
);

export const DeepDeleteButton = ({
  backPath,
  record,
  resource,
  inventory,
  className,
  ...props
}) => {
  const classes = useStyles();
  const dataProvider = useDataProvider();
  const history = useHistory();
  const notify = useNotify();
  const redirect = useRedirect();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleDialogOpen = () => setOpen(true);
  const handleDialogClose = () => setOpen(false);

  const handleDelete = async (event) => {
    setLoading(true);
    setOpen(false);
    try {
      debugger;
      await dataProvider.delete(resource, {
        id: record.id,
        previousData: record,
      });

      notify("Commodity deleted successfully", "success");
      deepRedirect(history, backPath);
    } catch (err) {
      logError(
        "commoditys:DeepDeleteButton:handleDelete",
        err,
        notify,
        redirect,
      );
    }
    setLoading(false);
  };

  if (
    !record ||
    record?.status === InventoryStatus.STORED ||
    record?.status === InventoryStatus.SHIPPED
  ) {
    return null;
  }
  return (
    <>
      <Button
        {...props}
        label="Delete"
        disabled={true || loading}
        onClick={handleDialogOpen}
        className={classnames(
          "ra-delete-button",
          classes.deleteButton,
          className,
        )}
      >
        <DeleteIcon />
      </Button>
      <Confirm
        isOpen={open}
        loading={loading}
        title="Delete Confirmation"
        content="Are you sure you want to delete this Commodity record?"
        onConfirm={handleDelete}
        onClose={handleDialogClose}
      />
    </>
  );
};
